<template>
    <div class="users-filters">
        <SearchInput
            class="customers-users__filter users-filters__search"
            :placeholder="$t('misc.search')"
            @change="onSearch"
        />

        <CustomSelect
            v-if="'role' in filters"
            class="users-filters__filter select--filter"
            :model-value="filters.role"
            emit-prop="value"
            view-label="display_name"
            :placeholder="$t('crm.users.list.role')"
            :options="roles"
            clearable
            @update:model-value="onChange('role', $event)"
        />
        <CustomSelect
            v-if="isInnerWorkspace && customers.length && 'customer_id' in filters"
            class="users-filters__filter select--filter"
            :model-value="filters.customer_id"
            emit-prop="id"
            :placeholder="$t('crm.users.list.customer')"
            view-label="name"
            :options="customers"
            clearable
            @update:model-value="onChange('customer_id', $event)"
        />
    </div>
</template>

<script>
import { SearchInput, CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { mapGetters } from 'vuex';

export default {
    name: 'UsersFilters',
    components: {
        SearchInput,
        CustomSelect,
    },
    props: {
        filters: {
            type: Object,
            default: () => {},
        },
        roles: {
            type: Array,
            default: () => [],
        },
        customers: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters('workspaces', ['isInnerWorkspace']),
    },
    methods: {
        onSearch(searchString) {
            this.$emit('search', searchString);
        },
        onChange(field, value) {
            this.$emit('filter', { [field]: value });
        },
    },
};
</script>

<style src="./UsersFilters.scss" lang="scss"></style>
